import { string } from "zod";

import { PhoneFormFieldValue, getFullPhoneNumber, validatePhoneNumber } from "@/ui";

const EMAIL_SCHEMA = string().email();

/**
 * Whether the email is a valid address. The uniqueness probe sends the email to
 * the backend, which rejects anything that isn't a valid email with a 400 — so we
 * only probe once it's valid (matching the form's own `zod` email rule), to avoid
 * wasting calls.
 */
export function isEmailFormatValid(email: string): boolean {
  return EMAIL_SCHEMA.safeParse(email).success;
}

export function getFullPhoneFromPhoneField(
  phone: PhoneFormFieldValue | null | undefined
): string | null {
  if (!phone?.nationalNumber) return null;
  return getFullPhoneNumber(phone.nationalNumber, phone.countryCode);
}

/**
 * Whether the phone field holds a fully valid number. The uniqueness probe sends
 * the number to the backend, which rejects anything that isn't a valid phone with
 * a 400 — so we only probe once the number is valid, to avoid wasting calls.
 */
export function isPhoneFieldValid(phone: PhoneFormFieldValue | null | undefined): boolean {
  if (!phone?.nationalNumber) return false;
  return validatePhoneNumber(phone.nationalNumber, phone.countryCode);
}
